// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"81":"35885ca1","594":"ca8d07a7"}[chunkId] + ".css";
};